import React from 'react'
import { Box } from '@mui/material'
import { format, parseISO } from 'date-fns'
import { DEFAULT_DATE_FORMAT } from '../../../constants/constants'
import { ApplicationStatusHistory } from '../../interfaces/ApplicationStatusHistory'

export const getCertificateTableColumns = () => {
  return [
    {
      field: 'nodots_drukāšanai_laiks',
      title: 'Izmaiņu datums',
      sorting: true,
      render: ({ nodots_drukāšanai_laiks }: ApplicationStatusHistory) => {
        if (!nodots_drukāšanai_laiks) {
          return undefined
        }

        return format(parseISO(nodots_drukāšanai_laiks), DEFAULT_DATE_FORMAT)
      },
    },
    {
      field: 'vārds',
      title: 'Vārds, uzvārds',
      sorting: true,
      render: (rowData: ApplicationStatusHistory) => {
        return <Box>{`${rowData.vārds} ${rowData.uzvārds}`}</Box>
      },
    },
    {
      field: 'personas_kods',
      title: 'Personas kods',
      sorting: true,
    },
    {
      field: 'numurs',
      title: 'Apliecības numurs',
      sorting: true,
    },
  ]
}
